<template>
  <el-card>
    <div class="page-tip">
      <div>固定 6 个徽章，仅支持编辑名称与图片，不支持新增和删除。</div>
      <div class="page-subtip">排序由系统按 1-6 固定控制，展示顺序与小程序“我的徽章”一致。</div>
    </div>

    <el-table :data="rows" border>
      <el-table-column prop="sortOrder" label="排序" width="80" />
      <el-table-column prop="badgeKey" label="徽章标识" width="180" />
      <el-table-column prop="badgeName" label="徽章名称" min-width="180" />
      <el-table-column prop="badgeImageUrl" label="徽章图片" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.badgeImageUrl" class="badge-preview">
            <img :src="scope.row.badgeImageUrl" class="badge-preview-image" />
          </div>
          <div v-else class="badge-preview badge-placeholder">
            <span>未上传</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="badgeImageUrl" label="图片地址" show-overflow-tooltip>
        <template slot-scope="scope">
          <span v-if="scope.row.badgeImageUrl">{{ scope.row.badgeImageUrl }}</span>
          <span v-else class="muted-text">未上传，前台将回退默认圆形文字徽章</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="edit(scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="visible" title="编辑徽章" width="600px">
      <el-form :model="form" label-width="110px">
        <el-form-item label="排序位置">
          <el-input :value="`第 ${form.sortOrder || '-'} 位（固定排序）`" disabled />
        </el-form-item>

        <el-form-item label="徽章标识">
          <el-input :value="form.badgeKey" disabled />
        </el-form-item>

        <el-form-item label="徽章名称">
          <el-input v-model="form.badgeName" maxlength="64" show-word-limit placeholder="请输入徽章名称" />
        </el-form-item>

        <el-form-item label="徽章图片">
          <el-upload
            :action="uploadAction"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
            accept="image/*"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">支持 jpg/png/gif/webp，建议上传 1:1 正方形图片，主体居中，避免边缘内容被圆形裁切。</div>
          </el-upload>
          <el-input v-model="form.badgeImageUrl" placeholder="或直接输入图片URL" style="margin-top:10px;" />
          <div class="editor-preview-wrap">
            <div v-if="form.badgeImageUrl" class="badge-preview editor-preview">
              <img :src="form.badgeImageUrl" class="badge-preview-image" />
            </div>
            <div v-else class="badge-preview badge-placeholder editor-preview">
              <span>未上传</span>
            </div>
            <div class="editor-preview-note">前台展示为圆形徽章，建议避免文字或关键图案贴边。</div>
          </div>
        </el-form-item>
      </el-form>

      <span slot="footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="submit">保存</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import { getBadgeList, updateBadge } from '@/api'

export default {
  data () {
    return {
      rows: [],
      visible: false,
      form: {},
      uploadAction: `${process.env.VUE_APP_BASE_API || '/api'}/file/upload`,
      uploadHeaders: {}
    }
  },
  created () {
    this.loadData()
    const token = localStorage.getItem('admin_token')
    if (token) {
      this.uploadHeaders.Authorization = `Bearer ${token}`
    }
  },
  methods: {
    async loadData () {
      const res = await getBadgeList()
      this.rows = res.data || []
    },
    edit (row) {
      this.form = { ...row }
      this.visible = true
    },
    beforeUpload (file) {
      const isImage = file.type.startsWith('image/')
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt5M) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    handleUploadSuccess (response) {
      if (response.code === 0 && response.data) {
        this.form.badgeImageUrl = response.data.url
        this.$message.success('上传成功')
      } else {
        this.$message.error(response.message || '上传失败')
      }
    },
    async submit () {
      if (!this.form.badgeName) {
        this.$message.error('请输入徽章名称')
        return
      }
      try {
        await updateBadge(this.form.id, {
          badgeName: this.form.badgeName,
          badgeImageUrl: this.form.badgeImageUrl || ''
        })
        this.$message.success('保存成功')
        this.visible = false
        this.loadData()
      } catch (error) {
        this.$message.error(error.message || '保存失败')
      }
    }
  }
}
</script>

<style scoped>
.page-tip {
  margin-bottom: 16px;
  color: #606266;
  line-height: 1.7;
}

.page-subtip,
.muted-text,
.editor-preview-note {
  color: #909399;
}

.badge-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  border: 1px solid #dcdfe6;
  border-radius: 50%;
  overflow: hidden;
  background: #f5f7fa;
}

.badge-preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.badge-placeholder {
  color: #c0c4cc;
  font-size: 12px;
}

.editor-preview-wrap {
  margin-top: 10px;
}

.editor-preview {
  width: 96px;
  height: 96px;
}

.editor-preview-note {
  margin-top: 8px;
  font-size: 12px;
}
</style>
